import { Component, inject, OnInit } from '@angular/core';
import { eModalRoles } from '../../../shared/models/modals';
import {
  DialogService,
  DynamicDialogConfig,
  DynamicDialogRef,
} from 'primeng/dynamicdialog';
import { MessageService } from 'primeng/api';
import { ExamDateComponent } from '../exam-date/exam-date.component';
import { centerDynamicModalConfig } from '../../../shared/helpers/modal.config';
import { IWordExamVm } from '../../../../api/word-exam-vm.model';
import { IUserWordExamQuestionVm } from '../../../../api/user-word-exam-question-vm.model';
import { Observable, of } from 'rxjs';
import { HtmlContentIm, PdfGeneratorService } from '../../../shared/services/pdf-generator.service';

@Component({
  selector: 'app-exam-view',

  templateUrl: './exam-view.component.html',
  styleUrl: './exam-view.component.scss',
})
export class ExamViewComponent implements OnInit {
  private _primengDialogService = inject(DialogService);
  private _messageService = inject(MessageService);
  private _dialogRef = inject(DynamicDialogRef);
  private _confifg = inject(DynamicDialogConfig);

  private _pdfGeneratorService = inject(PdfGeneratorService)

  public loading: boolean = false;
  public userAnswerCounts: { correct: number; incorrect: number } = {
    correct: 0,
    incorrect: 0,
  };
  public firstTableData: IUserWordExamQuestionVm[] = [];
  public secondTableData: IUserWordExamQuestionVm[] = [];

  private additionalDialogRef: DynamicDialogRef | undefined;

  public data: {
    wordExamDetails: IWordExamVm;
  } = this._confifg.data;

  private modalCloseStatus = eModalRoles.CLOSE;



  ngOnInit(): void {
    this.userAnswerCounts = this.getCorrectAndIncorrectAnswerCounts(
      this.data.wordExamDetails.examQuestions ?? []
    );
    this.divideArray(this.data.wordExamDetails.examQuestions ?? []);

  }

  ngOnDestroy(): void {
    if (this.additionalDialogRef) {
      this.additionalDialogRef.close(); // Closes the dialog if it's still open
      this.additionalDialogRef = undefined;
    }
  }

  private divideArray(examQuestionsList: IUserWordExamQuestionVm[]): void {
    const midIndex = Math.ceil(examQuestionsList.length / 2);
    this.firstTableData = examQuestionsList.slice(0, midIndex);
    this.secondTableData = examQuestionsList.slice(midIndex);
  }

  fetchExamQuestionDetails = (): Observable<IUserWordExamQuestionVm[]> => {
    return of(this.data.wordExamDetails.examQuestions ?? []);
  };

  closeDialog(status: eModalRoles = this.modalCloseStatus) {
    this._dialogRef.close(status);
  }

  printExam(): void {
    const printContents = document.getElementById('printSection')?.innerHTML;

    if (printContents) {

      const test = `
      <html>
        <head>
          <title></title> <!-- Empty title to prevent page title in print -->
          <style>
            @page {
              margin: 0;
            }

            body,
            table,
            th,
            td,
            div,
            p {
              margin: 0;
              padding: 0;
              box-sizing: border-box;
            }

            body {
              font-family: Inter, sans-serif;
              font-size: 12px;
              font-weight: 400; 
              padding: 16px;
              color: #000;
              line-height: normal;
            }


            /* General styles */
            .mb-3 {
              margin-bottom: 16px;
            }

            .w-full {
              width: 100%;
            }

            .font-normal {
              font-weight: 400;
            }

            .font-semibold {
              font-weight: 600;
            }

            .text-center {
              text-align: center;
            }

            .text-base {
              font-size: 16px;
            }

            .text-green-500 {
              color: #198754
            }

            .text-red-500 {
              color: #EF4444
            }

            .grid {
              display: flex;
              flex-wrap: wrap;
              margin-right: -0.5rem;
              margin-left: -0.5rem;
              margin-top: -0.5rem;
            }

            .col-6 {
              flex: 0 0 auto;
              padding: 0;
              width: 50%
            }

            .main-section {
              display: flex;
              flex-direction: column;
              gap: 16px;
            }

            .details-container {
              display: flex;
              flex-direction: row;
              gap: 52px;
            }

            .details-column {
              width: 100%;
              display: flex;
              flex-direction: column;
              gap: 8px;
            }

            .details-row {
              display: flex;
              justify-content: space-between;
              gap: 8px;
            }

            .exam-date-field {
              color: #000;
              font-size: 11px;
              font-style: normal;
              font-weight: 600;
              line-height: normal;
            }

            /* Table styles */
            .styled-print-table {
              width: 100%;
              border-collapse: collapse;
              border: 1px solid #D1D5DB;

            }

            .styled-print-table th {
              padding: 4px 4px;
              font-weight: 500;
              border: 1px solid #333;
            }

            .styled-print-table td {
              padding: 0px 4px;
              font-weight: 300; 
              border: 1px solid #F3F4F6;
            }

            .styled-print-table tbody tr:nth-child(even) {
              background-color: #F9FAFB;
            }

            .styled-print-table tbody tr td {
              color: #1E1F22;
              font-size: 12px;
              font-style: normal;
              font-weight: 300;
              line-height: 24px;
              text-align: center;

            }

            .styled-print-table thead tr th {
              color: #000;
              font-size: 11px;
              font-style: normal;
              font-weight: 500;
              line-height: 24px;
              text-align: center;
              font-weight: bold;

            }

            .styled-print-table tbody tr td:first-child {
              color: #000
              font-weight: bold;
              border: 1px solid #333 !important;
            }


            .styled-print-table td:nth-child(4) {
              font-weight: 600;
            }

            .footer-section {
              margin-top: 100px;
              display: flex;
              flex-direction: row;
              gap: 24px;
            }

            .separator {
              width: 100%;
              height: 1px;
              background-color: #d1d5db;
              margin-bottom: 4px;

            }

            .signature {
              color: #000;
              text-align: center;
              font-size: 10px;
              font-style: normal;
              font-weight: 400;
              line-height: normal;
            }
          </style>
        </head>
        <body>
          ${printContents}
        </body>
      </html>
    `;

   const htmlContent: HtmlContentIm = {
    body: test,
    footer: null,
    targetFileName: null,
    pagesTranslation: null,
    ofPagesTranslation: null,
   }

    this._pdfGeneratorService.post(htmlContent).subscribe({
      next: (blob) => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `Egzamin_wewnętrzny_${this.data.wordExamDetails.studentFirstName}_${this.data.wordExamDetails.studentLastName}.pdf`;
        link.click();
        window.URL.revokeObjectURL(url);
      },
    })
    }

  }


  changeExamDate(): void {
    this.openChangeExamDateModal(
      this.data.wordExamDetails.guid,
      this.data.wordExamDetails.end ?? new Date()
    );
  }

  getExamStatus(): { color: string; label: string } {
    const { earnedPoints, minimumPoints } = this.data.wordExamDetails;
    const examPassed = earnedPoints >= minimumPoints;

    return {
      color: examPassed ? 'text-green-500' : 'text-red-500',
      label: examPassed ? 'Egzamin zaliczony' : 'Egzamin niezaliczony',
    };
  }

  private openChangeExamDateModal(
    studentWordExamGuid: string,
    finishedDate: Date
  ): void {
    this.additionalDialogRef = this._primengDialogService.open(
      ExamDateComponent,
      {
        ...centerDynamicModalConfig,
        width: '579px',
        height: '695px',
        baseZIndex: 10001,
        data: {
          studentWordExamGuid,
          finishedDate,
        },
      }
    );

    this.additionalDialogRef.onClose.subscribe(
      (res: { status: eModalRoles; examEndDate: Date }) => {
        if (res.status === eModalRoles.REFRESH) {
          this.modalCloseStatus = res.status;
          this.data.wordExamDetails.end = res.examEndDate;
        }
      }
    );
  }

  private getCorrectAndIncorrectAnswerCounts(
    questions: IUserWordExamQuestionVm[]
  ): { correct: number; incorrect: number } {
    return questions.reduce(
      (acc, question) => {
        if (question.userGiveCorrectAnswer === true) {
          acc.correct++;
        } else {
          acc.incorrect++;
        }
        return acc;
      },
      { correct: 0, incorrect: 0 }
    );
  }
}
